import axios from "axios";
import {db} from "@src/services/db";
import GroupMessage from "@src/types/GroupMessage";

class GroupMessageService {
    async getGroupMessagesOld(groupId: number, oldestId: number | null) {
        try {
            let url = `operator/v4/groups/messages/${groupId}`;
            if (oldestId) url += `/${oldestId}`;

            const response = await axios.get(url, {withCredentials: true});
            return response.data;
        } catch (e) {
            console.error(e);
            return null;
        }
    }

    // async getGroupMessagesNew(groupId: number, afterId: number) {
    //     try {
    //         const url = `operator/v4/groups/messages-new/${groupId}/${afterId}`;
    //         const response = await axios.get(url, { withCredentials: true });
    //         return response.data; // {success,data,has_more,last_id}
    //     } catch (e) {
    //         console.error(e);
    //         return null;
    //     }
    // }

    async sendText(groupId: number, message: string, quoted?: number | null, tempId?: any) {
        try {
            const response = await axios.post(
                "operator/v4/groups/message/text",
                {
                    group_id: groupId,
                    message,
                    quoted: quoted ?? null,
                    temp_id: tempId ?? null,
                },
                {withCredentials: true}
            );

            // { success, id, message, temp_id }
            return response.data;
        } catch (e) {
            console.error(e);
            return null;
        }
    }

    async markAsRead(groupId: number) {
        // otimistic update: zera localmente antes da resposta
        await db.groups.update(groupId, {unread_count: 0} as any).catch(() => {
        })

        axios.post(
            `operator/v4/groups/${groupId}/mark-as-read`,
            {},
            {withCredentials: true}
        ).catch(() => {
        })
    }

    // atualizar last_message do grupo na sidebar
    async updateGroupLastMessage(groupId: number, lastMessage: GroupMessage | null | undefined) {
        try {
            if (!lastMessage) return;

            await db.groups.update(groupId, {
                last_message: {
                    ...lastMessage,
                    selected: false,
                },
                last_message_date: lastMessage.created_at ?? new Date().toISOString(),
            } as any);
        } catch (e) {
            console.error("❌ erro ao atualizar last_message do grupo", e);
        }
    }

    async addMember(groupId: number, costumerId: number) {
        const response = await axios.post(
            `operator/v4/groups/${groupId}/add-member/${costumerId}`,
            {},
            {withCredentials: true}
        )
        if (response.data.success) {
            await db.groups.update(groupId, {
                members: response.data.members
            })
            return response.data.members
        }
        return []
    }
}

export default new GroupMessageService();